import { ReactNode, useEffect, useState } from 'react';

import { Dropdown, DropdownOptionType } from '@hcs/design-system';
import { ObjectValuesType } from '@hcs/types';

import styles from './ZipMsaChartDropdownMobile.module.css';

const ANALYSIS_OPTIONS = {
  MarketActivity: 'Market Activity',
  MacroInsights: 'Macro Insights',
} as const;

type AnalysisOptionsValues = ObjectValuesType<typeof ANALYSIS_OPTIONS>;

interface Props {
  chartSelector?: ReactNode;
  market: ReactNode;
  macro: ReactNode;
}

const dataHcName = 'zip-charts-mobile-select';

export const GeoTypeChartDropdownMobile = ({
  chartSelector,
  market,
  macro,
}: Props) => {
  const [analysis, setAnalysis] = useState<AnalysisOptionsValues | undefined>(
    undefined,
  );
  const [analysisOptions, setAnalysisOptions] = useState<
    DropdownOptionType<AnalysisOptionsValues>[]
  >([]);

  // Update analysis state if the available options change and the current analysis is no longer available
  useEffect(() => {
    const newOptions: DropdownOptionType<AnalysisOptionsValues>[] = [];

    if (macro) {
      newOptions.push({
        label: ANALYSIS_OPTIONS.MacroInsights,
        value: ANALYSIS_OPTIONS.MacroInsights,
      });
    }

    if (market) {
      newOptions.push({
        label: ANALYSIS_OPTIONS.MarketActivity,
        value: ANALYSIS_OPTIONS.MarketActivity,
      });
    }

    setAnalysisOptions(newOptions);

    if (!newOptions.find((opt) => opt.value === analysis)) {
      setAnalysis(newOptions[0]?.value);
    }
  }, [market, macro, analysis]);

  if (analysisOptions.length === 0) return null;

  return (
    <>
      <div className={styles.DropdownRow}>
        <Dropdown
          dataHcName={dataHcName}
          isFloatingStyle={true}
          value={analysis}
          options={analysisOptions}
          onSelect={setAnalysis}
          className={styles.AnalysisDropdown}
        />
        {analysis === ANALYSIS_OPTIONS.MarketActivity ? chartSelector : null}
      </div>
      <div className={styles.Content}>
        {analysis === ANALYSIS_OPTIONS.MarketActivity ? market : null}
        {analysis === ANALYSIS_OPTIONS.MacroInsights ? macro : null}
      </div>
    </>
  );
};
